import { ChangeDetectorRef, Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoleFormatPipe } from '../../../../shared/pipes/role-format.pipe';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { RoleService } from '../../../../core/services/role.service';
import { Role } from '../../../../core/models/models';
import { RoleDialogComponent } from '../dialog/role-dialog.component';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
    selector: 'app-role-list',
    standalone: true,
    imports: [CommonModule, FormsModule, MatIconModule, MatDialogModule, MatPaginatorModule, RoleFormatPipe],
    templateUrl: './role-list.component.html',
    styleUrl: './role-list.component.scss'
})
export class RoleListComponent implements OnInit {
    roles: Role[] = [];
    errorMessage: string = '';
    successMessage: string = '';
    searchQuery = '';
    page = signal(0);
    size = signal(10);
    totalElements = signal(0);
    sortField = 'name';
    sortDirection = 'asc';

    private searchSubject = new Subject<string>();

    constructor(
        private roleService: RoleService,
        private dialog: MatDialog,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.loadRoles();
        this.searchSubject.pipe(
            debounceTime(400),
            distinctUntilChanged()
        ).subscribe(query => {
            this.searchQuery = query;
            this.page.set(0);
            this.loadRoles();
        });
    }

    loadRoles(): void {
        this.roleService
            .getPage(
                this.searchQuery,
                this.page(),
                this.size(),
                `${this.sortField},${this.sortDirection}`
            )
            .subscribe({
                next: (data) => {
                    this.roles = data.content;
                    this.totalElements.set(data.totalElements);
                    this.cdr.detectChanges();
                },
                error: () => {
                    this.errorMessage = 'Erreur lors du chargement des rôles';
                    this.cdr.detectChanges();
                }
            });
    }

    openCreateDialog(): void {
        const dialogRef = this.dialog.open(RoleDialogComponent, {
            width: '500px',
            data: {}
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.page.set(0);
                this.loadRoles();
            }
        });
    }

    openEditDialog(role: Role): void {
        const dialogRef = this.dialog.open(RoleDialogComponent, {
            width: '500px',
            data: { ...role }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.loadRoles();
            }
        });
    }

    onSearchChange(value: string): void {
        this.searchSubject.next(value);
    }

    onPageChange(event: PageEvent): void {
        this.page.set(event.pageIndex);
        this.size.set(event.pageSize);
        this.loadRoles();
    }
}
